import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { href: '/', label: '首页' },
    { href: '/category/yuepao-jiqiao', label: '约炮技巧' },
    { href: '/category/pingtai-tuijian', label: '平台推荐' },
    { href: '/category/liaotian-huashu', label: '聊天话术' },
    { href: '/category/anquan-zhinan', label: '安全指南' },
    { href: '/about', label: '关于我们' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 shrink-0">
              <span className="text-xl font-heading text-primary-500 font-bold">约炮攻略</span>
            </Link>

            <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                    location.pathname === link.href
                      ? 'text-primary-500 bg-primary-50'
                      : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="切换菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-foreground-950/40" onClick={() => setMobileOpen(false)}></div>
          <nav className="absolute top-16 left-0 right-0 bg-background-50 border-b border-background-200/70 py-3 px-4" aria-label="移动端导航">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`block py-3 px-4 text-base rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === link.href
                    ? 'text-primary-500 bg-primary-50 font-medium'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}

      <div className="h-16"></div>
    </>
  );
}